type AnalyticsEmptyStateProps = {
  message: string;
};

export function AnalyticsEmptyState({ message }: AnalyticsEmptyStateProps) {
  return (
    <div className="flex min-h-[180px] items-center justify-center rounded-[1.25rem] border border-dashed border-white/12 bg-black/15 px-5 py-8 text-center text-sm text-[#d7cab9]/70">
      {message}
    </div>
  );
}
